module.exports = __webpack_public_path__ + "media/images/emblems/Inkwil-coat_of_arms-df1b0ffb3ba6e0a4f8e9496848989456.svg";